var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendasNewIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8419 2.92863H12.5177C12.3141 2.92781 12.1166 2.99334 11.9593 3.11387C11.8021 3.2344 11.6949 3.40237 11.6564 3.58874C11.6179 3.7751 11.6504 3.96816 11.7484 4.13453C11.8464 4.3009 12.0036 4.43014 12.193 4.49989L13.5371 5.00095C13.7258 5.07098 13.8824 5.20012 13.98 5.36616C14.0776 5.5322 14.11 5.72476 14.0718 5.9107C14.0335 6.09665 13.9269 6.26434 13.7704 6.38494C13.6138 6.50554 13.417 6.5715 13.214 6.57148H11.8881",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8652 2.92858V2.32144",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8652 7.7857V6.57141",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.5584 9C15.0921 9 17.1461 7.09721 17.1461 4.75C17.1461 2.40279 15.0921 0.5 12.5584 0.5C10.0247 0.5 7.9707 2.40279 7.9707 4.75C7.9707 7.09721 10.0247 9 12.5584 9Z",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.0238 13.0446L16.9252 11.4653L16.9591 11.4557C17.2348 11.3948 17.5231 11.4371 17.7701 11.5749C18.0171 11.7126 18.206 11.9363 18.3015 12.2042C18.397 12.4721 18.3925 12.7659 18.289 13.0307C18.1854 13.2956 17.9899 13.5134 17.7388 13.6434C8.17018 18.6407 10.611 18.4149 0.630859 15.0613",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M0.630859 9.0005H2.35047C4.3492 8.9782 6.28815 9.74574 7.81099 11.1621L7.84304 11.1928H11.0478C11.3674 11.1928 11.674 11.3318 11.9 11.579C12.1261 11.8263 12.253 12.1616 12.253 12.5113C12.2533 12.86 12.1272 13.1945 11.9025 13.4418C11.6778 13.689 11.3727 13.8289 11.054 13.8307L6.18128 13.8572",
    stroke: "#737D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendasNewIcon);
export default __webpack_public_path__ + "static/media/vendas-new-icon.be340ba247792eca65f5e4e0e6a5770f.svg";
export { ForwardRef as ReactComponent };